import { render } from "./TeamPanel.vue?vue&type=template&id=edae7a44&scoped=true"
import script from "./TeamPanel.vue?vue&type=script&lang=js"
export * from "./TeamPanel.vue?vue&type=script&lang=js"

import "./TeamPanel.vue?vue&type=style&index=0&id=edae7a44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-edae7a44"

export default script